import React, {useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Showcase.module.css';
import NavigationMenu from './NavigationMenu';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BlurredTextBox from './BlurredTextBox';
import { BeatLoader } from 'react-spinners';
import baseStyles from './Home.module.css'
import HelpPopup from './HelpPopup';
import WidgetCustomization from './WidgetCustomization';
import Reminder from './Reminder';
import NotificationComponent from './NotificationComponent';

function Showcase() {
  const [widgetConfig, setWidgetConfig] = useState({
    strokeColor: "#ffffff",      // Default border color
    borderRadius: 10,           // Default border radius
    showStroke: true,           // Enable or disable border
    strokeThickness: 2,         // Default stroke thickness
    enableShadow: false,        // Enable or disable drop shadow
    shadowColor: "#000000",     // Default shadow color
    shadowBlur: 10,             // Default shadow blur
    shadowOffsetX: 0,           // Default shadow X offset
    shadowOffsetY: 0,           // Default shadow Y offset
  });
  const navigate = useNavigate();
  const [isTikTokLoggedIn, setIsTikTokLoggedIn] = useState(false); // State for tracking login status
  const [isLoading, setIsLoading] = useState(true); // State for tracking loading status
  const [imageUrl, setImageUrl] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status
  const [authToken, setAuthToken] = useState('');
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState(null); // Manage the error message
  const user = location.state?.user;
  const csrfState = Math.random().toString(36).substring(2);
  const [authWindow, setAuthWindow] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState(""); // Stores different messages

  let slideIndex = 0;
  var videoURLS = [];
  var LONG_ACCESSTOKEN = "";
  var REFRESH_TOKEN = "";
  var TiktokVideoData = [];
  var intervals = [];
  var sideNavSize = 300;

  useEffect(() => {
    const loadWidgetConfig = async () => {
      try {
        const userId = localStorage.getItem('_id');
        if (!userId) return;
        console.log("default widget info is: ", widgetConfig);
        const response = await axios.get(`https://dev.super-stream.co/api/getSettings/${userId}`);
        console.log("response is: ", response);
        console.log("settings is: ", response.data.settings);

        if (response.data && response.data.settings) {
          
          setWidgetConfig((prevConfig) => ({
            ...prevConfig,  // Preserve any missing fields with default values
            ...response.data.settings, // Override with saved settings
          }));
        }

      } catch (error) {
        console.error("Error loading widget settings:", error);
      }
    };
  
    loadWidgetConfig();
  }, []);

  useEffect(() => {
    console.log("loaded widget info is: ", widgetConfig);
  }, [widgetConfig]); // 🔍 Debugging if widgetConfig updates properly
  

// Watch for `authToken` changes and fetch the access token when it is set
useEffect(() => {
  const fetchAccessToken = async () => {
    console.log("FETCH ACCESS TOKEN", authToken);

    if (authToken) {
      try {
        await GetAccessTokenTikTok(authToken); // Fetch the access token
        setIsTikTokLoggedIn(true); // Set logged-in state
      } catch (error) {
        console.error("Error fetching access token:", error);
        setIsTikTokLoggedIn(false); // Handle error state
      }
    }
  };

  fetchAccessToken();
}, [authToken]); // Run this effect whenever `authToken` changes

useEffect(() => {
  // Check if user returned from TikTok login
  const authPending = localStorage.getItem("tiktokAuthPending");
  const token = window.location.search.substring(1); // Get token from URL

  if (authPending === "true" && token) {
      setIsTikTokLoggedIn(true); // Update state
      localStorage.setItem("tiktokLoggedIn", "true"); // Store login status
      localStorage.removeItem("tiktokAuthPending"); // Clear flag
      setAuthToken(token); // Store the token
      navigate("/showcase", { replace: true }); // Remove token from URL
  } else {
      // Check if user was already logged in from previous session
      const isLoggedIn = localStorage.getItem("tiktokLoggedIn") === "true";
      setIsTikTokLoggedIn(isLoggedIn);
  }
}, [navigate]);


  useEffect(() => {
    const checkTikTokLoginStatus = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code"); // Extract the `code` parameter
  
        if (code) {
          console.log("Found code in URL:", code);
  
          // Process the code to retrieve access tokens
          await GetAccessTokenTikTok(code);
          setIsTikTokLoggedIn(true);
  
          // Clear the URL after processing
          navigate("/showcase", { replace: true }); // Replace the current entry in the history stack
          return;
        }
  
        // If no code, check saved TikTok info
        const response = await axios.get(
          'https://dev.super-stream.co/api/getTiktokInfo/' + localStorage.getItem("_id")
        );
  
        LONG_ACCESSTOKEN = response.data.data.tiktokToken;
  
        if (LONG_ACCESSTOKEN) {
          await GetTiktokVideoData();
          setIsTikTokLoggedIn(true);
          ImageCarouselTimer();
        } else {
          setIsTikTokLoggedIn(false);
        }
      } catch (error) {
        console.error("Error during TikTok login check:", error);
        setIsTikTokLoggedIn(false);
      }
    };
  
    checkTikTokLoginStatus(); // Call the async function inside the effect
  }, [navigate]);

  useEffect(() => {
    function handleResize() {
      setIsCollapsed(window.innerWidth < (768 + sideNavSize));
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  

  // var isTikTokLoggedIn = false;
  const OpenAuth = () => {

      OpenAuthWindow();
  };

  function OpenAuthWindow() {
    const loginUrl = `https://www.tiktok.com/v2/auth/authorize/?client_key=awlpq7ud2ia3i66v&scope=user.info.basic,video.list,video.upload,video.publish&response_type=code&redirect_uri=https%3A%2F%2Fjoshmcgiff.github.io%2FtiktokRedirectStreamably%2F&state=${csrfState}`;
    
    // Store login intent in localStorage before redirecting
    localStorage.setItem("tiktokAuthPending", "true");

    // Redirect to TikTok login page
    window.location.href = loginUrl;
}

  async function GetTiktokVideoData(){
    const getTiktoksUrl = 'https://dev.super-stream.co/api/getTiktoks/' + LONG_ACCESSTOKEN + '?userId=' + localStorage.getItem('_id');    
    await fetch(getTiktoksUrl, {
                method: 'GET',
                redirect: 'follow',
                headers: {
                    'Content-Type': 'application/json',
                  },
                }
        )
    .then(response => response.json())
    .then(data => {
        let listOfEmbedLinks = '';
        let intervalArray = [];
        data.data.videos.forEach(function(video) {
            // do something with each video
            // for example, log the video's title
            intervalArray.push(video.duration);
            videoURLS.push(video.cover_image_url);
            listOfEmbedLinks = listOfEmbedLinks + video.embed_link +  "$&?!-_";
            
          });
          TiktokVideoData = listOfEmbedLinks;
          intervals = intervalArray;
          ImageCarouselTimer();
        // setIsLoading(false);
        // setIsLoggedIn(true);
        setIsTikTokLoggedIn(true);
       })
    .catch(error => console.log(error));
   
  }
  

  
  const convertHexToRGBA = (hex, opacity) => {
    let r = 0,
      g = 0,
      b = 0;
    if (hex.length === 7) {
      r = parseInt(hex.slice(1, 3), 16);
      g = parseInt(hex.slice(3, 5), 16);
      b = parseInt(hex.slice(5, 7), 16);
    }
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };
  const convertRGBAtoHex = (rgba) => {
    const result = rgba.match(/rgba?\((\d+), (\d+), (\d+),? ?([\d.]+)?\)/);
    if (!result) return "#000000";
    const r = parseInt(result[1]).toString(16).padStart(2, "0");
    const g = parseInt(result[2]).toString(16).padStart(2, "0");
    const b = parseInt(result[3]).toString(16).padStart(2, "0");
    return `#${r}${g}${b}`;
  };


  async function GetAccessTokenTikTok(tiktokToken){
    console.log("GETTING ACCESS TOKEN YOOOO");
    console.log("GETTING ACCESS TOKEN YOOOO", tiktokToken);

    const decodedToken = decodeURI(tiktokToken);
    const firstUrl = "https://dev.super-stream.co/api/getTiktokAccessToken/" + decodedToken;
    let responseLong = await fetch(firstUrl, {
      method: 'GET',
      redirect: 'follow',
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',

      },
    });

  let dataLong = await responseLong.json();
  LONG_ACCESSTOKEN = dataLong.access_token;
  REFRESH_TOKEN = dataLong.refresh_token;

  let postToken = await fetch('https://dev.super-stream.co/api/tiktok', {
    method: 'POST',
    redirect: 'follow',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({tiktokToken: LONG_ACCESSTOKEN, tiktokRefreshToken: REFRESH_TOKEN, id: localStorage.getItem('_id')})
  });

  let dataPost = await postToken.json();

  await GetTiktokVideoData();

  }

  var ImageCarouselTimerObject = null;
  function ImageCarouselTimer(){
    if(videoURLS.length == 0){
      return;
    }
    if(slideIndex < videoURLS.length){
      if(document.getElementById("imageCarousel") == null){
        ImageCarouselTimerObject = setTimeout(ImageCarouselTimer, 1000);
        slideIndex = 0;
      }else{
        document.getElementById('imageCarousel').style.display = '';
        document.getElementById("imageCarousel").src = videoURLS[slideIndex];
        slideIndex++;
        ImageCarouselTimerObject = setTimeout(ImageCarouselTimer, 1000);
        setIsLoading(false);
      }
    }else{
      slideIndex = 0;
      ImageCarouselTimer();
    }
  }

  const saveWidgetConfig = async () => {
    try {
      const response = await axios.put("https://dev.super-stream.co/api/saveSettings", {
        userId: localStorage.getItem('_id'),
        widgetConfig,
      });
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 3000); // Hide notification after 3 seconds
      console.log(response.data);
    } catch (error) {
      console.error("Error saving settings:", error);
    }
  };
 
  const handleConfigChange = (key, value) => {
    setWidgetConfig((prev) => ({ ...prev, [key]: value }));
    console.log("handling config change");
  };

  async function TiktokLogOut() {
    ImageCarouselTimerObject = null;
    LONG_ACCESSTOKEN = "";
    REFRESH_TOKEN = "";
    videoURLS = [];
    TiktokVideoData = [];
    intervals = [];
    // need to set widgetpreview stuff to blank - need to make a blank placeholder image for it
    await fetch('https://dev.super-stream.co/api/tiktok', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tiktokToken: "", tiktokRefreshToken: "", id: localStorage.getItem('_id') })
    });

    // Clear login state
    localStorage.removeItem("tiktokLoggedIn");
    setIsTikTokLoggedIn(false);
}

    return (
      <div className={`container-fluid`}>
          <div className="row">
              <div className="col">
                    <div className="row">
                      <div className={`col-2 nonScrollable ${isCollapsed ? `hideSidebar` : `showSidebar`}`}  style={{paddingRight: 0, paddingLeft: 0, width: sideNavSize + 'px'}}>
                            <NavigationMenu />
                      </div>
                      <div className={` col scrollable ${isCollapsed ? 'col-12' : ''}`} style={{ order: 1 }}>
                        <div className="scrollableContent">
                          <div className={styles["content-center"]}>
                            <img className={styles["responsive-image"]} src="images/showcasebanner.png" alt="Banner" />
                          </div>

                          {showNotification && (
                            <NotificationComponent message={notificationMessage} setShowNotification={setShowNotification} />
                          )}

                          {errorMessage && (
                              <div className="error-message">
                                <p style={{fontWeight: 'bold'}}>{errorMessage}</p>
                              </div>
                            )}

                          <div className='row'> {/* this is to make a grid system within the app window */}
                            <div className={styles.box} style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                                {!isTikTokLoggedIn ? (
                                  <button onClick={OpenAuth} type="button" className={`styles.button d-flex justify-content-center`} id="ConnectInstagramButton">Connect tiktok account</button>
                                ) : ( 
                                  null
                                )}
                              </div>
                          </div>

                          <HelpPopup 
                                  videoUrl="https://www.youtube.com/embed/AbyqFGWe8SQ?si=6qLpWsY1uKuu1KEx" 
                                  buttonLabel="?"
                                  popupTitle="Need Assistance?"
                                  popupMessage="Check out the tutorial below:"
                                  isTikTokLoggedIn={isTikTokLoggedIn} 
                                  TiktokLogOut={TiktokLogOut}
                                />

                        <div className={styles["optionspreviewrow"]}>
                          <div className={styles['customization-preview-container']}>
                            <div className={styles["content-center"]} style={{ margin: '10px' }}>
                              <WidgetCustomization
                              widgetConfig={widgetConfig}
                              onConfigChange={handleConfigChange}
                              convertHexToRGBA={convertHexToRGBA}
                              convertRGBAtoHex={convertRGBAtoHex}
                              blurredBoxText={"https://dev.super-stream.co/api/showcase/" + localStorage.getItem("_id")}
                              setShowNotification={setShowNotification}
                              setNotificationMessage={setNotificationMessage}
                              saveSettings={saveWidgetConfig}
                              />
                            </div>
                            <div className={styles["widget-preview-container"]} 
                              style={{flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '10px'
                              }}>               
                              <h3 style={{color: '#FECB00'}}>Widget Preview:</h3>
                              <div
                                className={styles["widget-preview"]}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "400px",
                                }}
                              >
                                <img
                                  id="imageCarousel"
                                  className={styles["preview-image"]}
                                  src={imageUrl}
                                  alt="Widget Preview"
                                  style={{
                                    width: "80%",
                                    height: "80%",
                                    objectFit: "cover",
                                    border: widgetConfig.showStroke
                                      ? `${widgetConfig.strokeThickness || 2}px solid ${widgetConfig.strokeColor}`
                                      : "none",
                                    borderRadius: `${widgetConfig.borderRadius}px`,
                                    boxShadow: widgetConfig.enableShadow
                                      ? `${widgetConfig.shadowOffsetX || 0}px ${
                                          widgetConfig.shadowOffsetY || 0
                                        }px ${widgetConfig.shadowBlur || 0}px ${
                                          widgetConfig.shadowColor || "#000000"
                                        }`
                                      : "none", // Disable shadow if not enabled
                                  }}
                                />
                              </div>
                              <Reminder/>
                              
                            </div>

                          </div>
                        </div>
                       
                            <div className="App content-centered">
                           
                                    
                                {localStorage.getItem('isSubscribed') === true || localStorage.getItem('isSubscribed') === "true" ? (<></>) : (
                                  <div className={styles.contained} style={{background: '#fecb00', border: '3px solid black', padding: '10px'}}>
                                          <div className={`row `}> {/* this is to make a grid system within the app window */}
                                            <div className='col-md-12'>
                                            <div className={`row `}>
                                              <div className={`col-md-12 d-flex justify-content-center `}>
                                                <h2>
                                                  Are you ready to <span className={baseStyles.logoText} style={{color: 'white', fontSize: 'inherit'}}>Supercharge</span> your stream?
                                                </h2>
                                              </div>
                                            </div>

                                              <div className={`row `}>
                                                <div className={`col-md-12 `}>
                                                  <p>
                                                    Unlock full access to <span className={baseStyles.logoText} style={{fontSize: 'inherit', color: 'black', textShadow: '0px 0px 0 black'}}>Showcase</span> with a subscription!
                                                  </p>
                                                </div>
                                              </div>

                                              

                                              <div className={`row `}>
                                                <div className={`col-md-12 `}>
                                                  <p>
                                                    Ads between TikToks ➡️ ✨ <span style={{fontWeight: 'bold'}}>Ad-free experience </span>✨
                                                  </p>
                                                </div>
                                              </div>

                                              <div className={`row `}>
                                                <div className={`col-md-12 `}>
                                                  <p>
                                                    Max. 3 TikToks ➡️ ⚡<span style={{fontWeight: 'bold'}}>Up to 20 TikToks </span>⚡
                                                  </p>
                                                </div>
                                              </div>

                                              <div className={`row `}>
                                                <div className={`col-md-12 justify-content-center d-flex`}>
                                                  <form action="/create-checkout-session" method="POST">
                                                    <input type="hidden" name="id" value={localStorage.getItem("_id")} />
                                                    <input type="hidden" name="lookup_key" value="tier_1" />
                                                    <button id="checkout-and-portal-button" type="submit">
                                                      Subscribe
                                                    </button>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                  </div>
                                )}

                                

                                

                                    
                            </div>
            
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
  
  export default Showcase;